/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1LocationCountriesCountryidLangsIdMutationRequest,
  PutApiV1LocationCountriesCountryidLangsIdMutationResponse,
  PutApiV1LocationCountriesCountryidLangsIdPathParams,
  PutApiV1LocationCountriesCountryidLangsId400,
  PutApiV1LocationCountriesCountryidLangsId401,
  PutApiV1LocationCountriesCountryidLangsId404,
  PutApiV1LocationCountriesCountryidLangsId500,
} from "../../types/locationCountryLangController/PutApiV1LocationCountriesCountryidLangsId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1LocationCountriesCountryidLangsId } from "../../clients/locationCountryLangController/putApiV1LocationCountriesCountryidLangsId.ts";

export const putApiV1LocationCountriesCountryidLangsIdMutationKey = () =>
  [{ url: "/api/v1/location/countries/:countryId/langs/:id" }] as const;

export type PutApiV1LocationCountriesCountryidLangsIdMutationKey = ReturnType<
  typeof putApiV1LocationCountriesCountryidLangsIdMutationKey
>;

export function putApiV1LocationCountriesCountryidLangsIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1LocationCountriesCountryidLangsIdMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1LocationCountriesCountryidLangsIdMutationKey();
  return mutationOptions<
    PutApiV1LocationCountriesCountryidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCountriesCountryidLangsId400
      | PutApiV1LocationCountriesCountryidLangsId401
      | PutApiV1LocationCountriesCountryidLangsId404
      | PutApiV1LocationCountriesCountryidLangsId500
    >,
    {
      countryId: PutApiV1LocationCountriesCountryidLangsIdPathParams["countryId"];
      id: PutApiV1LocationCountriesCountryidLangsIdPathParams["id"];
      data?: PutApiV1LocationCountriesCountryidLangsIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ countryId, id, data }) => {
      return putApiV1LocationCountriesCountryidLangsId(
        countryId,
        id,
        data,
        config,
      );
    },
  });
}

/**
 * @description Atualiza os dados de uma tradução (idioma) de país. **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma do país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:countryId/langs/:id}
 */
export function usePutApiV1LocationCountriesCountryidLangsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1LocationCountriesCountryidLangsIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1LocationCountriesCountryidLangsId400
        | PutApiV1LocationCountriesCountryidLangsId401
        | PutApiV1LocationCountriesCountryidLangsId404
        | PutApiV1LocationCountriesCountryidLangsId500
      >,
      {
        countryId: PutApiV1LocationCountriesCountryidLangsIdPathParams["countryId"];
        id: PutApiV1LocationCountriesCountryidLangsIdPathParams["id"];
        data?: PutApiV1LocationCountriesCountryidLangsIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1LocationCountriesCountryidLangsIdMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1LocationCountriesCountryidLangsIdMutationKey();

  const baseOptions = putApiV1LocationCountriesCountryidLangsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1LocationCountriesCountryidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCountriesCountryidLangsId400
      | PutApiV1LocationCountriesCountryidLangsId401
      | PutApiV1LocationCountriesCountryidLangsId404
      | PutApiV1LocationCountriesCountryidLangsId500
    >,
    {
      countryId: PutApiV1LocationCountriesCountryidLangsIdPathParams["countryId"];
      id: PutApiV1LocationCountriesCountryidLangsIdPathParams["id"];
      data?: PutApiV1LocationCountriesCountryidLangsIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1LocationCountriesCountryidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCountriesCountryidLangsId400
      | PutApiV1LocationCountriesCountryidLangsId401
      | PutApiV1LocationCountriesCountryidLangsId404
      | PutApiV1LocationCountriesCountryidLangsId500
    >,
    {
      countryId: PutApiV1LocationCountriesCountryidLangsIdPathParams["countryId"];
      id: PutApiV1LocationCountriesCountryidLangsIdPathParams["id"];
      data?: PutApiV1LocationCountriesCountryidLangsIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1LocationCountriesCountryidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCountriesCountryidLangsId400
      | PutApiV1LocationCountriesCountryidLangsId401
      | PutApiV1LocationCountriesCountryidLangsId404
      | PutApiV1LocationCountriesCountryidLangsId500
    >,
    {
      countryId: PutApiV1LocationCountriesCountryidLangsIdPathParams["countryId"];
      id: PutApiV1LocationCountriesCountryidLangsIdPathParams["id"];
      data?: PutApiV1LocationCountriesCountryidLangsIdMutationRequest;
    },
    TContext
  >;
}
